import React from 'react';
import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NS, PROFILE_KEYS } from '../../../i18n/constants/keys';
import { SectionCard } from '../../../ui/mui';
import { AccountPreferencesLocked, PasswordRow } from './PersonalSection';
import { TwoFactorSettings } from './TwoFactorSettings';

export const AccountSection = () => {
  const { t } = useTranslation(NS.profile);

  const handleChangePassword = (): void => {
    window.location.href = '/change-password';
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <SectionCard
        title={t(PROFILE_KEYS.sections.account.title)}
        subtitle={t(PROFILE_KEYS.sections.account.intro)}
      >
        <Stack spacing={2.5}>
          <Box>
            <PasswordRow onChangePassword={handleChangePassword} />
          </Box>
          <TwoFactorSettings />
        </Stack>
      </SectionCard>

      <SectionCard title={t(PROFILE_KEYS.account.preferences)}>
        <AccountPreferencesLocked />
      </SectionCard>
    </Box>
  );
};
